import {injectable} from 'inversify';

import {ServiceLocator} from '../../../IoC/services/ServiceLocator';

@injectable()
export class CoreServiceLocator extends ServiceLocator {}
